import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Card from "../components/Card";

import {
  setMCQContext,
  getMCQContext
} from "../utils/mcqContext";

export default function McqModule() {

  const { id: subject_id } =
    useParams();

  const location =
    useLocation();

  const navigate =
    useNavigate();

  const [modules, setModules] =
    useState([]);

  const [isMobile, setIsMobile] =
    useState(
      window.innerWidth < 768
    );

  const queryParams =
    new URLSearchParams(
      location.search
    );

  const querySubjectId =
    queryParams.get(
      "subject_id"
    );

  const teacherId =
    queryParams.get(
      "teacher_id"
    );

  /* ================= RESPONSIVE ================= */

  useEffect(() => {

    const handleResize = () => {

      setIsMobile(
        window.innerWidth < 768
      );

    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () =>

      window.removeEventListener(
        "resize",
        handleResize
      );

  }, []);

  /* ================= NAVBAR HIDE / TOP SHOW ONLY ================= */

  useEffect(() => {

    const navbar =
      document.querySelector(
        ".navbar"
      );

    const handleScroll = () => {

      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

      else {

        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";

        navbar.style.opacity =
          "0";

      }

    };

    if (navbar) {

      navbar.style.position =
        "fixed";

      navbar.style.top =
        "15px";

      navbar.style.left =
        "50%";

      navbar.style.width =
        "90%";

      navbar.style.maxWidth =
        "1100px";

      navbar.style.transform =
        "translateX(-50%)";

      navbar.style.zIndex =
        "9999";

      navbar.style.transition =
        "all 0.35s ease";

    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {

      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

    };

  }, []);

  /* ================= FETCH MODULES ================= */

  useEffect(() => {

    const backendSubjectId =
      querySubjectId ||
      subject_id;

    if (!backendSubjectId)
      return;

    fetch(
      `https://edunet.kmechengineering.com/root-engine1/api/module-data?subject_id=${backendSubjectId}`
    )

      .then((res) =>
        res.json()
      )

      .then((data) => {

        const moduleList =
          Array.isArray(
            data.module_data
          )
            ? data.module_data
            : [];

        setModules(
          moduleList
        );

      })

      .catch((err) => {

        console.error(
          "Error loading modules:",
          err
        );

        setModules([]);

      });

  }, [
    subject_id,
    querySubjectId
  ]);

  return (

    <div
      className="mcq-page"
      style={{
        padding: isMobile
          ? "20px 12px"
          : "40px",
      }}
    >

      <h2
        className="mcq-title"
        style={{
          textAlign:
            "center",

          fontSize:
            isMobile
              ? "22px"
              : "28px",

          marginBottom:
            isMobile
              ? "20px"
              : "30px"
        }}
      >

        Select Module

      </h2>

      <div className="card-grid">

        {modules.length ===
          0 && (

          <p
            style={{
              color:
                "#fff",

              textAlign:
                "center"
            }}
          >

            No modules available

          </p>

        )}

        {modules.map((m) => (

          <div
            key={
              m.module_id
            }
            style={{
              transform:
                isMobile
                  ? "scale(0.98)"
                  : "none"
            }}
          >

            <Card

              title={
                m.module_name
              }

              subtitle={
                m.description
              }

              avatarText={m.module_name
                ?.substring(
                  0,
                  2
                )
                .toUpperCase()}

              gradient="linear-gradient(135deg,#f97316,#ea580c)"

              onClick={() => {

                localStorage.removeItem("review_mcq_data");

                const moduleId = m.module_id;

                const context = getMCQContext() || {};

                setMCQContext({
                  ...context,
                  subjectId: context?.subjectId,
                  subjectName: context?.subjectName,
                  teacherId: teacherId,
                  teacherName: context?.teacherName,
                  moduleId: moduleId,
                });

                const flowType =
                  localStorage.getItem("flow_type") || "mcq";

                const isPaid =
                  context?.type === "paid";

                if (teacherId) {

                  // Paid Flow
                  if (isPaid) {

                    navigate(`/dashboard?flow=${flowType}`);

                  }

                  // Free Flow
                  else {

                    if (flowType === "essay") {

                      navigate(
                        `/essay/paper/${teacherId}?module_id=${moduleId}`
                      );

                    } else {

                      navigate(
                        `/mcq/free/teacher/${teacherId}?module_id=${moduleId}`
                      );

                    }

                  }

                }

                // Select By Module
                else {

                  if (flowType === "essay") {

                    navigate(
                      `/essay/subject/${subject_id}?module_id=${moduleId}`,
                      {
                        state: {
                          type: "essay",
                        },
                      }
                    );

                  } else {

                    navigate(
                      `/mcq/subject/${subject_id}?module_id=${moduleId}`,
                      {
                        state: {
                          type: "mcq",
                        },
                      }
                    );

                  }

                }

              }}

            />

          </div>

        ))}

      </div>

    </div>

  );

}
